module.exports = __webpack_public_path__ + "static/index/img/baikal-502.a089e96d.jpg";